import Constants from "../constants";

export default {
  install: Vue => {
    Object.defineProperty(Vue.prototype, "$constant", { value: Constants });
  }
};
